import { observer } from 'mobx-react'
import './index.scss'
import ThingsCan from '../ThingsCan'
import Directions from '../Directions'
import Terms from '../Terms'
import Arrange from '../Arrange'
import Support from '../Support'
import classNames from 'classnames'
import { useLocation } from 'react-router'
import FamousShops from '../FamousShops'
import HowItWork from '../HowItWork'
import PopularShops from '../PopularShops'

const ThingsCol = observer(
  ({ content, linkblock }: { content: any; linkblock: string }) => {
    const { pathname } = useLocation()

    return (
      <section
        className={classNames(
          'things-col',
          // pathname.includes('business') && 'dark-theme',
        )}
        id={linkblock}
      >
        <div className="things-col__cat">
          <img src={content.catIcon} />
          {content.cat}
        </div>
        <div className="things-col__title">{content.title}</div>
        <div
          className="things-col__text"
          dangerouslySetInnerHTML={{ __html: content.text }}
        ></div>
        {!content.ch1 && <ThingsCan content={content.can} />}
        {!content.ch2 && (
          <Directions content={content.directs2} classname={'bg'} />
        )}
        {!content.ch3 && <PopularShops content={content.popshops} />}
        {!content.ch4 && (
          <Directions content={content.directs} classname={''} />
        )}
        {!content.ch9 && <FamousShops content={content.shops} />}

        {!content.ch5 && <Terms content={content.terms} />}
        {!content.ch6 && (
          <Arrange content={content.arrange} linkblock={linkblock} />
        )}
        {!content.ch7 && (
          <HowItWork content={content.howwork} linkblock={linkblock} />
        )}
        {!content.ch8 && (
          <Support content={content.support} linkblock={linkblock} />
        )}
      </section>
    )
  },
)

export default ThingsCol
